import React, { useState } from 'react'
import {
    Box,
    Divider,
    Flex,
    Heading,
    HStack,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Image
  } from '@chakra-ui/react'
import { Link as ReactRouterLink } from 'react-router-dom';
function DocumentAttached({ paryData, verified, hideStatus }) {
    const [isOpen1, setIsOpen1] = useState(false);
    const onClose1 = () => setIsOpen1(false);
    const onOpen1 = () => setIsOpen1(true);
    const [openIdProofModal, setOpenIdProofModal] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure()
    const photographURL = paryData.PartyContent.filter((d) => d.contentTypeEnumId === "PHOTOGRAPH")
    const panURL = paryData.PartyContent.filter((d) => d.contentTypeEnumId === "PAN")
    const linkedinUrl = paryData.PartyContent.filter((d) => d.contentTypeEnumId === "LINKEDIN_PROFILE")[0]
    const idProof = paryData.PartyContent.filter((d) => d.contentTypeEnumId === "IDPROOF")[0]
    
    // console.log(IdProof, '8888888888888')
    const openIdProof = () => {
        setOpenIdProofModal(true)
    }
    const closeIdProof = () => {
        setOpenIdProofModal(false)
    }
   return (
    <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} bgColor={'#FFFFFF'} my={5} p={3}>
    <Heading size={'md'} mb={2}>{`Documents Attached`}</Heading>
    <Divider size={1} my={2} borderBottomColor={'black'} />
    {((hideStatus !== "ORDER_DELIVERED") && (hideStatus !== "ORDER_VERIFIED")) &&
    <HStack spacing={10} py={2} my={2}>
    
        <Flex w={'100%'} justifyContent={'space-between'}>
            <Box>
                <Text as={ReactRouterLink} to="#" textDecoration="underline" onClick={onOpen1} color="rgba(67, 138, 254, 1)">
                    pancard/documents
                </Text>
            </Box>
        </Flex>
    </HStack>
            }
    <HStack spacing={10} py={2} my={2}>
        <Flex w={'100%'} justifyContent={'space-between'}>
            <Box>
                <Text as={ReactRouterLink} to="#" textDecoration="underline"  onClick={onOpen}  color="rgba(67, 138, 254, 1)">
                    customer photo
                </Text>
            </Box>
        </Flex>
    </HStack>
    <HStack spacing={10} py={2} my={2}>
        <Flex w={'100%'} justifyContent={'space-between'}>
            <Box>
                <Text as={ReactRouterLink} to="#" textDecoration="underline" color="rgba(67, 138, 254, 1)">
                    bankaccountstatement
                </Text>
            </Box>
        </Flex>
    </HStack>
    <HStack spacing={10} py={2} my={2}>
        <Flex w={'100%'} justifyContent={'space-between'}>
            <Box>
                <Text as={ReactRouterLink} to="#" textDecoration="underline" color="rgba(67, 138, 254, 1)">
                    additionaldocuments
                </Text>
            </Box>
        </Flex>
    </HStack>

    {
        linkedinUrl ?    (<HStack spacing={10} py={2} my={2}>
            <Flex w={'100%'} justifyContent={'space-between'}>
                <Box>
                    <a href={`https://${linkedinUrl.contentUrl.replace('https://', '')}`} target="_blank" rel="noreferrer">
                        <Text textDecoration="underline" color="rgba(67, 138, 254, 1)">
                            LinkedIn Profile
                        </Text>
                    </a>
                </Box>
            </Flex>
        </HStack>): null
    }

    {
        idProof ?    (<HStack spacing={10} py={2} my={2}>
            <Flex w={'100%'} justifyContent={'space-between'}>
                <Box>
                    <Text textDecoration="underline" onClick={() => openIdProof()} color="rgba(67, 138, 254, 1)">
                        College ID
                    </Text>
                </Box>
            </Flex>
        </HStack>) : null
    }
    
    


    {/* PAN MODAL */}
    <Modal isOpen={isOpen1} onClose={onClose1}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader textAlign={'center'}>Customer Pan</ModalHeader>
          <Divider border={'1px solid gray'}/>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent={'center'} flexWrap={'wrap'} gap={'15px'} alignItems={'center'} flexDirection={'column'}>
                {panURL.length > 0 ?
                    panURL.map((x) => {
                        return (
                    <Text as={ReactRouterLink} to={x.contentUrl} mx={4} target={'_blank'}  _first={{marginLeft: '0px'}} key={x.id}>
                        <Image
                        boxSize='atuo'
                        objectFit='cover'
                        src={x.contentUrl}
                        alt={x.contentTypeEnumId}/>
                    </Text>  
                        )
                    })
                :
                <>
                    <Text>Not Available</Text>
                </>
            }
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose1} display={'block'} width={'100%'}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Customer Photot MODAL */}
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader textAlign={'center'}>Customer Photo</ModalHeader>
          <Divider border={'1px solid gray'}/>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent={'center'} flexWrap={'wrap'} gap={'15px'} alignItems={'center'} flexDirection={'column'}>
                {photographURL.length > 0 ?
              
                    photographURL.map((d) => {
                        return (
                        <Text as={ReactRouterLink} to={d.contentUrl} mx={4} target={'_blank'}  _first={{marginLeft: '0px'}} key={d.id}>
                        <Image
                         boxSize='atuo'
                        objectFit='cover'
                        src={d.contentUrl}
                        alt={d.contentTypeEnumId}/>
                    </Text>  
                        )
                    })
                  
                :
                <>
                    <Text>Not Available</Text>
                </>
            }
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose} display={'block'} width={'100%'}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={openIdProofModal} onClose={closeIdProof}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader textAlign={'center'}>ID proof</ModalHeader>
          <Divider border={'1px solid gray'}/>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent={'center'} flexWrap={'wrap'} gap={'15px'} alignItems={'center'} flexDirection={'column'}>
                {
                    idProof ?  (<Text as={ReactRouterLink} to={idProof.contentUrl} mx={4} target={'_blank'}  _first={{marginLeft: '0px'}} key={idProof.id}>
                    <Image
                     boxSize='atuo'
                    objectFit='cover'
                    src={idProof.contentUrl}
                    alt={idProof.contentUrl}/>
                </Text>  ) : <Text>Not Available</Text>
                }
                    
                  
            
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={closeIdProof} display={'block'} width={'100%'}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  </Box>
  )
}

export default DocumentAttached